import { Check } from "lucide-react";

const STEPS = [["source", "Your singing"], ["sing", "Check phrase"], ["creating", "Building"], ["ready", "Ready"]];
const ORDER = { phrase: 1, sing: 1, creating: 2, ready: 3, error: 1, broken: 1 };

/** 4-step progress strip for one Suno voice. */
export default function VoiceSteps({ status }) {
  const at = ORDER[status] ?? 1;
  return (
    <ol data-testid="suno-voice-steps" data-step={at} className="grid grid-cols-4 gap-2">
      {STEPS.map(([k, label], i) => {
        const done = i < at || status === "ready";
        const now = i === at && status !== "ready";
        return (
          <li key={k} data-testid={`suno-voice-step-${k}`} data-state={done ? "done" : now ? "now" : "todo"}
            className={`rounded-2xl border px-3 py-2.5 transition-colors ${done ? "border-emerald-400/30 bg-emerald-400/[0.07]" : now ? "border-cyan-300/50 bg-cyan-300/[0.08]" : "border-white/[0.06] bg-white/[0.02]"}`}>
            <span className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.14em] text-white/50">
              {done ? <Check className="h-3 w-3 text-emerald-300" /> : `0${i + 1}`}
            </span>
            <span className={`mt-0.5 block text-[13px] font-semibold ${done || now ? "text-white" : "text-white/45"}`}>{label}</span>
          </li>
        );
      })}
    </ol>
  );
}
